import React from "react";
import config from "../../config";
import { ProtocolType, Sso } from "@modules/sso";

const SSOConnect = () => <Sso config={config.ssoConfig} protocol={ProtocolType.OAUTH_PKCE_PROTOCOL} />;

export default SSOConnect;
